// ANGEL FLIGHT — intro cinematic ("LAST BIRD UP") tunables + copy.
//
// The intro is a presentation-only cue list run by app/IntroCinematic between
// the Briefing DEPLOY and combat start (GameLoop.introHold gates the sim; the
// world keeps rendering/scrolling). All timings are seconds from cinematic
// start. Skippable any time; ?dev= quickstarts bypass it entirely.

export const CINEMATIC = {
  /** Master switch — the future account/profile gating hook flips this. */
  enabled: true,
  /** The campaign opener that carries the intro. */
  missionId: 'm1-overpass',

  /** Typewriter speed for all typed copy. */
  charsPerSec: 34,

  // ── Cinematic framing: letterbox film bars that ease in when the live world
  //    is revealed and retract on the gameplay hand-off (a filmic frame over
  //    the opener; presentation-only). ────────────────────────────────────────
  /** Bar height as a fraction of viewport height (top + bottom each). */
  letterboxFrac: 0.11,
  /** Bar slide-in duration when the live world is revealed. */
  letterboxInS: 0.8,

  // ── Phase A: black screen + radio traffic ────────────────────────────────
  radioLines: [
    '18:42 — ANGEL-6, SAY AGAIN. ANGEL-6?',
    '18:44 — ANGEL-6 IS DOWN AT THE INTERCHANGE.',
    '18:47 — ALL STATIONS: ANGEL-7 IS THE LAST BIRD UP.',
  ],
  radioStartS: [0.6, 3.2, 5.8],
  /** Hidden thermal round-trip behind the blackout so the FLIR EffectPass
   *  compiles before the visible blinks (no first-blink hitch). */
  precompileThermalOnS: 0.15,
  precompileThermalOffS: 0.7,

  // ── Phase B: reveal the live world, no gun, Reyes line ───────────────────
  revealS: 8.4,
  revealFadeS: 0.9,
  reyes1S: 9.8,
  reyes1: 'REYES: You strapped in back there?',

  // ── Phase C: gun-cam FLIR boot blinks ────────────────────────────────────
  blink1S: 14.2,
  blink2S: 15.4,
  blinkLenS: 0.22,
  selftest1: ['GUN CAM SELF-TEST', 'FLIR... OK   TRACK... OK'],
  selftest2: ['FEED... LIVE'],
  selftestClearS: 16.6,

  // ── Phase D: the minigun rises + one spin pulse ──────────────────────────
  gunRiseS: 16.8,
  gunRiseLenS: 1.5,
  /** How far below the rest pose the gun starts (overlay-scene units, -Y). */
  gunDropY: -1.5,
  spinPulseS: 17.6,
  spinPulseLenS: 1.6,
  reyes2S: 18.6,
  reyes2: "REYES: Sight's yours. Tracers will walk where your finger walks.",
  controlHint: 'HOLD — fire · TAP — single shot',

  // ── Phase E: title + hand-off ────────────────────────────────────────────
  titleS: 21.8,
  title: 'ANGEL FLIGHT',
  subtitle: 'Last bird up.',
  reyes3: 'REYES: Overpass first. We promised them a corridor.',
  endS: 25.8,
  endFadeS: 0.7,
} as const;
